import {withTranslation} from "react-i18next";
import {Button, InputAdornment, makeStyles, Modal, TextField, Typography} from "@material-ui/core";
import {poolActions} from "../../../redux/actions/poolActions";
import React from "react";
import {roundingDown} from "../../../utils/RoundingDown";
import {useDispatch, useSelector} from "react-redux";

const LiquidityHistoryDetail = (props) =>{
    const {
        onCancel: handleClose,
        modalVisible,
        values,
    } = props;
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        }
    }));
    const classes = useStyles();

    const resultViewBody = (
        <div className={classes.paper}>
            <h2 id="simple-modal-title">交易详情</h2>
            <Typography>
                时间: {values.createdAt}
            </Typography>
            <Typography>
                操作: {values.type === 1?"添加流动性":values.type === 2?"解除流动性":null} {roundingDown(values.amount1,8)} {values.token1} + {roundingDown(values.amount2,8)} {values.token2}
            </Typography>
            <Typography>
                {values.type === 1?"获得":values.type === 2?"减少":null} {values.token1}-{values.token2}-LP: {roundingDown(values.lpTokenAmount,8)}
            </Typography>
        </div>
    );
    return (
        <Modal
            open={modalVisible}
            onClose={handleClose}
            className={classes.modal}
        >
            {resultViewBody}
        </Modal>
    )
}
export default withTranslation()(LiquidityHistoryDetail);